/**
 * @file 左上角搜索面板容器（对齐 OPM Editor 布局与样式）
 */

import React from 'react';
import SearchPanel from './SearchPanel';

const TopLeftPanel: React.FC = () => {
  return (
    <div className="top-left-panel">
      <div className="top-left-panel-content">
        <SearchPanel />
      </div>
    </div>
  );
};

export default TopLeftPanel;
